import React from 'react'
import { createRoot } from 'react-dom/client'

import TravelFeeCalculator from '../tools/TravelFeeCalculator'

// The public travel fee calculator (/tools/travel-fee-calculator). The page
// opens with a full load (turbo-visit-control), so this runs every time.
const container = document.getElementById('travel-fee-calculator')
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <TravelFeeCalculator lookups={container.dataset.lookups === 'true'} defaults={JSON.parse(container.dataset.defaults)} />
    </React.StrictMode>
  )
}
